import React from 'react';
import { useTranslation } from 'react-i18next';
import { Navigate, useNavigate } from 'react-router-dom';
import { useGlobalContext } from '../../context/GlobalContext';
import AccessibleContent from '../../utils/AccessibleContent';

const StoreSelection = () => {
  const { store, selectedStore, setCurrentStore } = useGlobalContext();
  const { t } = useTranslation();
  const navigate = useNavigate();

  if (!store || !store.physical_store || !store.cards) {
    return <Navigate to="/home" replace />;
  }

  const lang = store.lang || 'fr';
  const firstPhysicalVisual = store.cards.find(
    card => card.store === 'physical' || card.store === 'both'
  )?.src;
  const firstDigitalVisual = store.cards.find(
    card => card.store === 'digital' || card.store === 'both'
  )?.src;

  const handleStoreSelection = (storeType) => {
    setCurrentStore(storeType);
    navigate(`/home/${storeType}`);
  };

  return (
    <>
      <div id="topSection">
        <div
          className={`overlayBox ${store.physical_store.choice_img ? 'overlay' : ''}`}
          style={{ backgroundImage: `url(${store.physical_store.choice_img})` }}
        >
          <div className="wrapper">
            <div
              className="headContent accrocheColor"
              dangerouslySetInnerHTML={{
                __html: store.physical_store.texts.choice_teaser[lang] || ''
              }}
            ></div>
          </div>
        </div>
      </div>
      <div className="stores">
        <div>
          {firstPhysicalVisual && (
            <img src={firstPhysicalVisual} alt="physique" />
          )}
          <div>
            <button
              onClick={() => handleStoreSelection('physical')}
              className="btn"
            >
              {t("Offrir une carte physique")}
            </button>
          </div>
          <AccessibleContent
            htmlContent={store.physical_store.texts.choice_main_physical[lang] || ''}

          />

        </div>
        <div>
          {firstDigitalVisual && (
            <img src={firstDigitalVisual} alt="digitale" />
          )}
          <div>
            <button
              onClick={() => handleStoreSelection('digital')}
              className="btn"
            >
              {t("Offrir une carte digital")}
            </button>
          </div>
          <AccessibleContent
            htmlContent={store.physical_store.texts.choice_main_digital[lang] || ''}

          />

        </div>
      </div>
    </>
  );
};

export default StoreSelection;